import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * Lists all approval rows for a payment (including revoked ones) for display
 * in the payment detail UI.
 */
export function usePaymentApprovals(paymentId: string, enabled = true) {
  const query = useQuery({
    ...orpc.finance.payments.listApprovals.queryOptions({
      input: { paymentId },
    }),
    enabled: enabled && Boolean(paymentId),
  });

  return {
    ...query,
    approvals: query.data?.approvals ?? [],
  };
}
